const WORLD_CUP_START = new Date("2026-06-11T00:00:00");

export function getDaysUntilWorldCup() {
  const startOfToday = new Date();
  startOfToday.setHours(0, 0, 0, 0);
  const millisecondsRemaining = WORLD_CUP_START.getTime() - startOfToday.getTime();

  return Math.max(0, Math.ceil(millisecondsRemaining / (1000 * 60 * 60 * 24)));
}
